import { Modal } from 'bootstrap';
import naja from "naja";

class FormsConfirmDialogExtension {

    initialize(naja) {
        FormsConfirmDialogExtension.cleanupLegacyCookies();
        this.initializeForms();
        naja.addEventListener('complete', this.initializeForms.bind(this));
    }

    static cleanupLegacyCookies() {
        if (sessionStorage.getItem('fcd-cookies-cleaned')) return;
        const oneDayMs = 24 * 60 * 60 * 1000;
        document.cookie.split(';').forEach(cookie => {
            const eqIdx = cookie.indexOf('=');
            if (eqIdx === -1) return;
            const name = cookie.slice(0, eqIdx).trim();
            if (!name.startsWith('formData_') && !name.startsWith('initialFormData_')) return;
            // přemigruj data do localStorage pokud tam ještě nejsou
            if (!localStorage.getItem(name)) {
                try {
                    const raw = decodeURIComponent(cookie.slice(eqIdx + 1).trim());
                    const data = JSON.parse(raw);
                    localStorage.setItem(name, JSON.stringify({ data, expires: Date.now() + oneDayMs }));
                } catch (e) {}
            }
            document.cookie = name + '=; Max-Age=-99999999; path=/';
        });
        sessionStorage.setItem('fcd-cookies-cleaned', '1');
    }

    initializeForms(event) {
        $('form[data-form-confirm-dialog="true"]').each((index, form) => {
            const formConfirmDialog = new FormConfirmDialog($(form));
            formConfirmDialog.initialize();
        });
    }
}
export default FormsConfirmDialogExtension;

class FormConfirmDialog {
    // Sdílené napříč všemi instancemi (initializeForms vytváří novou instanci při
    // každém naja 'complete'): pamatuje si poslední známý DOM uzel <form> pro dané id,
    // aby šlo poznat, jestli byl formulář mezitím opravdu nahrazen AJAX snippetem.
    static knownFormNodes = new Map();

    constructor(form) {
        this.form = form;
        this.initialValues = {};
        this.modalOpen = false;
        this.callbackSend = false;
        this.lastSubmittedFormId = null;
        this.enabledRestore = !!this.form.find('.on-change-reload-form').length;
        this.ignoreFormDialogClass = 'ignore-form-dialog';
        this.cookiePrefix = 'formData_';
        this.cookieInitialPrefix = 'initialFormData_';
        this.cookieExpireDays = 1;

        this.handleInteraction = this.handleInteraction.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
        this.handleRestoreChangedState = this.handleRestoreChangedState.bind(this);
        this.handleIgnoreFormDialogClick = this.handleIgnoreFormDialogClick.bind(this);
    }

    loadValue(element) {
        let currentValue;
        if ($(element).attr('type') === 'checkbox') {
            currentValue = $(element).prop('checked');
        } else if ($(element).is('select[multiple]')) {
            currentValue = $(element).val() || [];
        } else {
            currentValue = $(element).val();
        }

        this.initialValues[element.id] = currentValue;
    }

    setCookie(name, value, days) {
        const expires = days ? Date.now() + days * 24 * 60 * 60 * 1000 : null;
        try {
            localStorage.setItem(name, JSON.stringify({ data: value, expires }));
        } catch (e) {}
    }

    getCookie(name) {
        try {
            const raw = localStorage.getItem(name);
            if (!raw) return null;
            const item = JSON.parse(raw);
            if (item.expires && Date.now() > item.expires) {
                localStorage.removeItem(name);
                return null;
            }
            return item.data;
        } catch (e) {
            return null;
        }
    }

    deleteCookie(name) {
        localStorage.removeItem(name);
    }

    // Získání unikátního klíče pro uložení dat formuláře
    getFormKey() {
        const formId = this.form.attr('id');
        if (!formId) return null;

        // Použijeme pathname pro stabilitu, action může obsahovat dynamické signály
        let path = window.location.pathname;

        // Aby klíč byl bezpečný pro cookie (nepovoluje určité znaky), nahradíme vše kromě alfanumerických znaků a pomlček/podtržítek
        let sanitizedPath = path.replace(/[^a-z0-9]/gi, '_');

        return formId + '_' + sanitizedPath;
    }

    // Uložení dat formuláře do cookie
    saveFormData() {
        const formKey = this.getFormKey();
        if (!formKey) return;

        const formData = {};
        this.form.find('input, textarea, select').each((index, element) => {
            if (!element.id) return;

            let value;
            if ($(element).attr('type') === 'checkbox') {
                value = $(element).prop('checked');
            } else if ($(element).is('select[multiple]')) {
                value = $(element).val() || [];
            } else {
                value = $(element).val();
            }
            formData[element.id] = value;
        });

        this.setCookie(this.cookiePrefix + formKey, formData, this.cookieExpireDays);

        // Uložit i initialValues do cookie, pokud tam nejsou, aby přežily reload/AJAX
        const initialInCookie = this.getCookie(this.cookieInitialPrefix + formKey);
        if (!initialInCookie && Object.keys(this.initialValues).length > 0) {
            this.setCookie(this.cookieInitialPrefix + formKey, this.initialValues, this.cookieExpireDays);
        }
    }

    // Obnovení dat formuláře z cookie
    restoreFormData() {
        const formKey = this.getFormKey();
        if (!formKey) return;

        const formData = this.getCookie(this.cookiePrefix + formKey);
        if (!formData) return;

        for (const elementId in formData) {
            const element = this.form.find('#' + elementId);
            if (element.length) {
                const newValue = formData[elementId];
                const previousValue = element.attr('type') === 'checkbox' ? element.prop('checked') : element.val();

                if (element.attr('type') === 'checkbox') {
                    element.prop('checked', newValue);
                } else if (element.is('select[multiple]')) {
                    element.val(newValue);
                } else {
                    element.val(newValue);
                }

                // .val() nevyvolá žádný event. Prvky s data-onchange-link (např.
                // výběr skladu) si ale musí donačíst závislá data (grid), jinak by
                // obnovený formulář vypadal vyplněně, ale zůstal nefunkční. Dřív to
                // suploval 100ms poller v initOnchangeLink (a dělal fantomové
                // requesty) – teď to řešíme jedním cíleným, namespacovaným eventem,
                // který obslouží jen handler onchange-linku, žádný jiný.
                if (element.attr('data-onchange-link') && element.val() !== previousValue) {
                    element.trigger('change.onchangeLink');
                }

                // Pokud element existoval i v initialValues, musíme ho porovnat
                this.handleInputChange(element);
            }
        }
    }

    cleanFormDataFromCookie() {
        const formKey = this.getFormKey();
        if (formKey) {
            this.deleteCookie(this.cookiePrefix + formKey);
            this.deleteCookie(this.cookieInitialPrefix + formKey);
        }
    }

    handleInputChange(element) {
        let id = $(element).attr('id');
        if (!id) return;

        const $el = this.form.find('#' + id);

        if ($el.length === 0) {
            return;
        }

        if ($el.is(':disabled') || $el.attr('readonly')) {
            $el.removeClass('changed');
            return;
        }

        let currentValue;
        if ($el.attr('type') === 'checkbox') {
            currentValue = $el.prop('checked');
        } else if ($el.is('select[multiple]')) {
            currentValue = $el.val() || [];
        } else {
            currentValue = $el.val();
        }

        let isChanged = false;
        let initialValue = this.initialValues[id];

        if (initialValue === undefined) {
            // Zkusíme najít bez prefixu ID formuláře, pokud tam je
            const formId = this.form.attr('id');
            if (formId && id.startsWith(formId + '-')) {
                const shortId = id.substring(formId.length + 1);
                initialValue = this.initialValues[shortId];
            }
        }

        if (initialValue === undefined) {
            // Pokud stále nemáme původní hodnotu, zkusíme ji načíst teď (jako fallback)
            this.loadValue(element);
            initialValue = this.initialValues[id];
        }

        if (Array.isArray(currentValue) && Array.isArray(initialValue)) {
            const currentSorted = [...currentValue].map(String).sort();
            const initialSorted = [...initialValue].map(String).sort();
            isChanged = (currentSorted.toString() !== initialSorted.toString());
        } else {
            // Použití != pro volnější porovnání
            let cv = (currentValue === null || currentValue === undefined) ? '' : String(currentValue);
            let iv = (initialValue === null || initialValue === undefined) ? '' : String(initialValue);

            if (cv !== iv) {
                // Speciální ošetření pro data a datetime (např. 20.03.2026 vs 2026-03-20, nebo s časem)
                const dateRegex = /^\d{2}\.\d{2}\.\d{4}$/;
                const dateTimeRegex = /^\d{2}\.\d{2}\.\d{4} \d{2}:\d{2}$/;
                const isoDateTimeRegex = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(?::\d{2})?$/;

                const normalizeDate = (val) => {
                    if (dateRegex.test(val)) {
                        const parts = val.split('.');
                        return `${parts[2]}-${parts[1]}-${parts[0]}`;
                    }
                    if (dateTimeRegex.test(val)) {
                        const [datePart, timePart] = val.split(' ');
                        const parts = datePart.split('.');
                        return `${parts[2]}-${parts[1]}-${parts[0]}T${timePart}`;
                    }
                    if (isoDateTimeRegex.test(val)) {
                        // Normalize ISO to YYYY-MM-DDTHH:mm (remove seconds if present)
                        return val.replace(' ', 'T').substring(0, 16);
                    }
                    return val;
                };

                let ncv = normalizeDate(cv);
                let niv = normalizeDate(iv);

                if (niv === '0' && ncv === '') {
                    niv = '';
                }

                if (ncv !== niv) {
                    isChanged = true;
                }
            }
        }

        if (isChanged) {
            $el.addClass('changed');
        }
        // zakomentováno, protože např. při změně ve formuláři vyýdejky a následném vyhledávání našeptávače produktů se na formuláři odstranil stav "changed" a dalo se odejít bez uložení 
        /*else {
            $el.removeClass('changed');
        }*/
    }

    handleRestoreChangedState(event) {
        if (!this.enabledRestore) {
            return;
        }

        // Pokud jde o AJAX požadavek, znovu načteme form, protože se mohl změnit snippet
        const id = this.form.attr('id');
        if (id) {
            this.form = $(`#${id}`);
        }

        this.form.find('input, textarea, select').each((index, element) => {
            this.handleInputChange(element);
        });
    }

    // Obsluha kliknutí na prvek s třídou ignore-form-dialog
    handleIgnoreFormDialogClick(event) {
        const formId = this.form.attr('id');
        if (formId && this.isFormChanged()) {
            this.saveFormData();
        }
    }

    isFormChanged() {
        if (this.form.attr('data-disable-change-warning')) {
            return false;
        }

        let changed = false;
        this.form.find('input, textarea, select').each((index, element) => {
            const el = $(element);
            if (el.hasClass('changed') && !el.is(':disabled') && !el.attr('readonly')) {
                changed = true;
                return true;
            }
        });

        return changed;
    }

    cleanChangedInputs() {
        const formKey = this.getFormKey();
        this.form.find('input, textarea, select').each((index, element) => {
            $(element).removeClass('changed');
            this.loadValue(element);
        });

        console.log('cleanChangedInputs', formKey);

        // Smazání cookie po úspěšném odeslání formuláře
        if (formKey) {
            this.deleteCookie(this.cookiePrefix + formKey);
            this.deleteCookie(this.cookieInitialPrefix + formKey);
        }
    }



    initialize() {
        let id = this.form.attr('id');
        this.form = $(`#${id}`);
        if (this.form.hasClass('ignore-changes')) {
            return;
        }

        if (this.form.closest('.confirm-dialog-wrapper').length) {
            let wrapper = this.form.closest('.confirm-dialog-wrapper');
            if (wrapper.hasClass('confirm-dialog-wrapper-initialized')) {
                return;
            }
            wrapper.addClass('confirm-dialog-wrapper-initialized');
        } else {
            if (this.form.hasClass('confirm-dialog-initialized')) {
                // FormsConfirmDialogExtension volá initialize() po KAŽDÉM naja 'complete'
                // požadavku na stránce, i takovém, který se s tímto formulářem vůbec
                // nepojí (např. výběr hodnoty přes selectable-grid iframe). restoreFormData()
                // smí přepsat aktuální hodnoty tou starou schránkou z localStorage jen tehdy,
                // když byl <form> uzel skutečně nahrazen AJAXem vykresleným snippetem –
                // jinak by se právě zadaná (ještě neuložená) hodnota vzápětí přepsala zpět
                // na stav z doby posledního saveFormData() (typicky z přidání první položky).
                const currentNode = this.form[0];
                if (currentNode && FormConfirmDialog.knownFormNodes.get(id) !== currentNode) {
                    this.restoreFormData();
                }
                FormConfirmDialog.knownFormNodes.set(id, currentNode);

                // Po obnovení dat musíme znovu projít inputy a nastavit .changed,
                // protože se mohl změnit snippet po AJAXu
                this.form.find('input, textarea, select').each((index, element) => {
                    this.handleInputChange(element);
                });
                return;
            }
            this.form.addClass('confirm-dialog-initialized');
            FormConfirmDialog.knownFormNodes.set(id, this.form[0]);
        }

        const formKey = this.getFormKey();
        const initialValuesFromCookie = this.getCookie(this.cookieInitialPrefix + (formKey || id));
        if (initialValuesFromCookie) {
            this.initialValues = initialValuesFromCookie;
        } else {
            this.initialValues = {};
        }

        // Nejprve inicializujeme inputy a jejich eventy
        this.form.find('input, textarea, select').each((index, element) => {
            if (!initialValuesFromCookie) {
                this.loadValue(element);
            }

            $(element).off('change.confirmDialog keyup.confirmDialog').on('change.confirmDialog keyup.confirmDialog', (e) => {
                this.handleInputChange(e.target);
            });
        });

        // Poté obnovíme data z cookie (to vyvolá handleInputChange a nastaví .changed)
        this.restoreFormData();

        // Pojistka pro asynchronně načtené prvky - zkráceno
        setTimeout(() => {
            this.form.find('input, textarea, select').each((index, element) => {
                if (Object.keys(this.initialValues).length === 0 || !this.initialValues[element.id]) {
                    if (!initialValuesFromCookie) {
                        this.loadValue(element);
                    }
                }
                this.handleInputChange(element);
            });
        }, 100);

        // Přidání posluchačů událostí pro prvky s třídou ignore-form-dialog
        $(document).off('click.ignoreDialog').on('click.ignoreDialog', `.${this.ignoreFormDialogClass}`, this.handleIgnoreFormDialogClick);

        naja.uiHandler.addEventListener('interaction', this.handleInteraction);
        $(document).off('click.anchor').on('click.anchor', 'a', this.handleClick);
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        naja.addEventListener('complete', this.handleRestoreChangedState);
        naja.addEventListener('before', (event) => {
            const {request, options} = event.detail;

            // Zkusíme najít form ID z různých zdrojů
            let formId = null;
            let isOnChangeSkipValidation = false;

            // Pomocná funkce pro získání dat z body (FormData nebo objekt s metodou get)
            const getFromBody = (body, key) => {
                if (!body) return null;
                if (typeof body.get === 'function') return body.get(key);
                if (typeof body === 'object' && body[key]) return body[key];
                return null;
            };

            const hasInBody = (body, key) => {
                if (!body) return false;
                if (typeof body.has === 'function') return body.has(key);
                if (typeof body === 'object' && body.hasOwnProperty(key)) return true;
                return false;
            };

            if (request.method === 'POST' && request.body) {
                if (typeof request.body === 'string') {
                    const searchParams = new URLSearchParams(request.body);
                    formId = searchParams.get('_form_id') || searchParams.get('_do');
                    isOnChangeSkipValidation = searchParams.has('onChangeSkipValidation');
                } else {
                    formId = getFromBody(request.body, '_form_id') || getFromBody(request.body, '_do');
                    isOnChangeSkipValidation = hasInBody(request.body, 'onChangeSkipValidation');

                    // Pokud je body FormData, ale instanceof selhal, zkusíme iterovat (pouze pro debug/nouzi)
                    if (!isOnChangeSkipValidation && typeof request.body.forEach === 'function') {
                        request.body.forEach((value, key) => {
                            if (key === 'onChangeSkipValidation') isOnChangeSkipValidation = true;
                            if (key === '_form_id' && !formId) formId = value;
                        });
                    }
                }

            if (formId && typeof formId === 'string' && formId.includes('-')) {
                const parts = formId.split('-');
                if (parts.length > 1) {
                    const potentialFormId = 'frm-' + formId.replace(/-submit$/, '');
                    if ($(`#${potentialFormId}`).length) {
                        formId = potentialFormId;
                    }
                }
            }
        }

        if (!formId && options) {
                if (options.form) {
                    formId = $(options.form).attr('id');
                } else if (options.element) {
                    const $el = $(options.element);
                    const $form = $el.closest('form');
                    formId = $form.length ? $form.attr('id') : null;
                    isOnChangeSkipValidation = isOnChangeSkipValidation || $el.hasClass('on-change-skip-validation');
                } else if (options.nette && options.nette.el) {
                    const $form = $(options.nette.el).closest('form');
                    formId = $form.length ? $form.attr('id') : null;
                }

                if (!isOnChangeSkipValidation && options.onChangeSkipValidation) {
                    isOnChangeSkipValidation = true;
                }

                if (!isOnChangeSkipValidation && options.body) {
                    isOnChangeSkipValidation = hasInBody(options.body, 'onChangeSkipValidation');
                }
            }

            // Pokud nic nepomohlo, zkusíme URL parametry
            if (!isOnChangeSkipValidation && request.url) {
                const url = new URL(request.url, window.location.origin);
                if (url.searchParams.has('onChangeSkipValidation')) {
                    isOnChangeSkipValidation = true;
                }
            }

            this.lastSubmittedFormId = formId;
            this.lastIsOnChangeSkipValidation = isOnChangeSkipValidation;

            if (isOnChangeSkipValidation && formId && (this.form.is(`#${formId}`) || (typeof formId === 'string' && formId.includes(this.form.attr('id'))))) {
                this.saveFormData();
            }
        });

        naja.addEventListener('success', (event) => {
            const {request, payload} = event.detail;

            const isPost = request.method === 'POST';
            const isOnChangeSkipValidation = (payload && payload.onChangeSkipValidation) || this.lastIsOnChangeSkipValidation;
            const formIdInFormData = this.lastSubmittedFormId;
            const thisFormId = this.form.attr('id');
            const isFormMatchFormData = formIdInFormData && (formIdInFormData === thisFormId || formIdInFormData.includes(thisFormId));
            const bodyIsString = request.body && typeof request.body === 'string';
            const bodyIncludesId = bodyIsString && request.body.includes(thisFormId);

            const isThisFormSuccess = (isPost && isFormMatchFormData) || bodyIncludesId;

            if (isThisFormSuccess && this.callbackSend && !isOnChangeSkipValidation) {
                this.cleanChangedInputs();
                this.callbackSend = false;
            }

            if (isPost && this.callbackSend && !isOnChangeSkipValidation) {
                this.callbackSend = false;
            }
        });

        const modal = this.form.closest('.modal').not('.ignore-form-dialog');
            modal.on('hide.bs.modal', (e) => {
                if (!this.callbackSend && this.isFormChanged()) {
                    const modal2 = modal.find('.modal.ignore-form-dialog');
                    if (modal2.length) {
                        return;
                    }

                    e.preventDefault();
                    this.showConfirmDialog(
                        () => {
                            if (modal.find('input[type=submit]').length === 1) {
                                modal.find('input[type=submit]').trigger('click');
                            } else if (modal.find('input[name=submitBack]').length === 1) {
                                modal.find('input[name=submitBack]').trigger('click');
                            } else if (modal.find('input[name=submit]').length === 1) {
                                modal.find('input[name=submit]').trigger('click');
                            }
                        },
                        modal.length ? modal[0] : null
                );
                }
            });
    }

    shouldIgnoreDialog(element) {
        const $element = $(element);

        return $element.parent().parent().length === 0 // pro autocomplete
            || $element.hasClass(this.ignoreFormDialogClass)
            || $element.closest(`.${this.ignoreFormDialogClass}`).length > 0
            || $element.attr('data-modal') === 'true'
            || $element.closest('[data-modal="true"]').length > 0;
    }

    handleInteraction(event) {
        let {element} = event.detail;
        element = $(element);

        if (this.shouldIgnoreDialog(element)) {
            // Ukládání dat při kliknutí na prvek s třídou ignore-form-dialog
            if (element.hasClass(this.ignoreFormDialogClass) || element.closest(`.${this.ignoreFormDialogClass}`).length > 0) {
                if (this.isFormChanged()) {
                    this.saveFormData();
                }
            }

            this.callbackSend = true;
            return;
        }

        if (!element.closest('form.ajax').length && !element.hasClass('list-group-item-action') && this.isFormChanged() && !this.modalOpen && $.contains(document.body, this.form[0])) {
            event.preventDefault();
            this.showConfirmDialog(() => {
                naja.makeRequest('GET', element.attr('href'), null, {history: true});
            });
        } else {
            this.callbackSend = true;
        }

        if (element.attr('name') === '_submit' || element.attr('name') === 'submitBack') {
            this.cleanChangedInputs();
        }
    }

    handleClick(event) {
        const target = $(event.target);

        // Dohledat <a> s href: primárně až 2 úrovně výše, jinak první vnořený <a>
        const anchorEl = target.is('a[href]')
            ? target
            : (target.parent('a[href]').length ? target.parent('a[href]')
                : (target.parent().parent('a[href]').length ? target.parent().parent('a[href]')
                    : target.find('a[href]').first()));
        const targetHref = anchorEl.attr('href');

        if (this.shouldIgnoreDialog(target)) {
            // Ukládání dat při kliknutí na prvek s třídou ignore-form-dialog
            if (target.hasClass(this.ignoreFormDialogClass) || target.closest(`.${this.ignoreFormDialogClass}`).length > 0) {
                if (this.isFormChanged()) {
                    this.saveFormData();
                }
            }

            this.callbackSend = true;
            return;
        }

        if ((!target.closest('form.ajax').length || !target.hasClass('ajax')) && this.isFormChanged() && !this.modalOpen && $.contains(document.body, this.form[0]) && !target.attr('data-disable-change-warning') && !target.closest('a[data-disable-change-warning]').length) {
            event.preventDefault();
            this.showConfirmDialog(() => {
                window.location.href = targetHref;
            });
        } else {
            this.callbackSend = true;
        }
    }

    handleBeforeUnload(event) {
        if (this.isFormChanged() && !this.callbackSend) {
            // Smažeme cookies hned, jak se zobrazí dialog prohlížeče.
            // Pokud uživatel zůstane na stránce (dialog zavře přes Cancel/Zůstat),
            // cookies se znovu uloží při dalším uložení dat nebo při AJAXu.
            this.cleanFormDataFromCookie();
            event.preventDefault();
            event.returnValue = '';
        }
    }

    showConfirmDialog(yesCallback, parentModalEl = null) {
        const closeParentModal = () => {
            if (!parentModalEl) return;

            const parentInstance = Modal.getInstance(parentModalEl) || new Modal(parentModalEl);
            parentInstance.hide();
        };

        const modal = document.createElement('div');
        modal.classList.add('modal', 'fade');
        modal.tabIndex = -1;
        modal.role = 'dialog';
        modal.innerHTML = `
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Ve formuláři došlo ke změnám.</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-footer d-flex justify-content-between">
                    <button type="button" class="btn btn-success">Uložit a pokračovat</button>
                    <button type="button" class="btn btn-warning">Neukládat a pokračovat</button>                    
                    <button type="button" class="btn btn-secondary">Zpět</button>
                </div>
            </div>
        </div>
        `;

        document.body.appendChild(modal);

        const bootstrapModal = new Modal(modal);
        modal.querySelector('.btn-success').addEventListener(
            'click', (ev) => {
                if (!window.Nette.validateForm(this.form[0])) {
                    bootstrapModal.hide();
                    this.modalOpen = false;

                    const flashMessage = $('<div class="alert-danger alert mt-3 alert-dismissible fade show">Formulář obsahuje chyby a nelze jej uložit.<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>');
                    $('.alert-fixed').append(flashMessage);
                    setTimeout(function () {
                        flashMessage.find('.btn-close').click();
                    }, 6000);

                    return;
                }

                // Smazání cookies před nebo po úspěšném odeslání
                this.cleanChangedInputs();

                const handleSuccess = (event) => {
                    naja.removeEventListener('success', handleSuccess);
                    yesCallback();
                };

                if (this.form.closest('.modal')) {
                        const submitButton = this.form.find('input[type=submit], button[type=submit]').first();
                        if (submitButton.length) {
                            this.destroyCallbacks();
                            bootstrapModal.hide();
                            this.modalOpen = false;
                            this.callbackSend = true;
                            naja.addEventListener('success', handleSuccess);
                            submitButton.trigger('click');
                            this.callbackSend = false;
                        } else {
                            this.destroyCallbacks();
                            bootstrapModal.hide();
                            this.modalOpen = false;
                            this.callbackSend = true;
                            yesCallback();
                            this.callbackSend = false;
                        }
                } else if (this.form.hasClass('ajax')) {
                    const submitButton = this.form.find('input[type=submit], button[type=submit]').first();
                    if (submitButton.length) {
                        this.destroyCallbacks();
                        bootstrapModal.hide();
                        this.modalOpen = false;
                        this.callbackSend = true;
                        naja.addEventListener('success', handleSuccess);
                        submitButton.trigger('click');
                        this.callbackSend = false;
                    } else {
                        naja.uiHandler.submitForm(this.form[0]).then((response) => {
                            this.destroyCallbacks();
                            bootstrapModal.hide();
                            this.modalOpen = false;
                            this.callbackSend = true;
                            yesCallback();
                            this.callbackSend = false;
                        });
                    }
                } else {
                    bootstrapModal.hide();
                    this.modalOpen = false;
                    const submitButton = this.form.find('input[type=submit], button[type=submit]').first();
                    if (submitButton.length) {
                        submitButton.trigger('click');
                    } else {
                        this.form.submit();
                    }
                }
            }
        );
        modal.querySelector('.btn-warning').addEventListener(
            'click', () => {
                this.cleanChangedInputs();
                this.callbackSend = true;
                this.modalOpen = false;

                const $openModals = $('.modal.show:visible').filter((i, el) => el !== modal);

                if ($openModals.length) {
                    const lastModalEl = $openModals.get($openModals.length - 1);
                    const inst = Modal.getInstance(lastModalEl) || new Modal(lastModalEl);
                    inst.hide();
                }

                const onHidden = () => {
                    modal.removeEventListener('hidden.bs.modal', onHidden);
                    modal.remove();
                    yesCallback();
                    this.callbackSend = false;
                };

                modal.addEventListener('hidden.bs.modal', onHidden, { once: true });
                bootstrapModal.hide();
            }
        );
        modal.querySelector('.btn-secondary').addEventListener(
            'click', () => {
                bootstrapModal.hide();
                this.modalOpen = false;
            }
        );
        modal.addEventListener('hidden.bs.modal', () => {
            this.modalOpen = false;
        });

        this.modalOpen = true;
        bootstrapModal.show();
    }

    destroyCallbacks() {
        naja.uiHandler.removeEventListener('interaction', this.handleInteraction);
        $(document).off('click', 'a', this.handleClick);
        $(document).off('click', `.${this.ignoreFormDialogClass}`, this.handleIgnoreFormDialogClick);
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }
}
